<template>
  <transition name="router-fade"
              mode="out-in">
    <div class="app-content">
      <router-view></router-view>
    </div>
  </transition>
</template>

<style lang="scss">
@import './styles/base.scss';
@import './styles/main.scss';
</style>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
</style>
